import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarTypeService {

	private isInternalCalendarSubject = new BehaviorSubject<boolean>( this.getStoredCalendarType() );
	isInternalCalendar$ = this.isInternalCalendarSubject.asObservable();


	setInternalCalendar(isInternal: boolean) {
		console.log("Kalendertypeservice", isInternal);
		this.isInternalCalendarSubject.next(isInternal);
		localStorage.setItem('calendarType', isInternal ? 'internal' : 'external');
	}


	private getStoredCalendarType(): boolean {
		const storedType = localStorage.getItem('calendarType');
		return storedType === 'internal';
	}
}
